export default __webpack_public_path__ + "static/media/steak5.b7bce2bd.png";